import React, {ReactNode} from 'react';

import {InnerLink} from './styled';

interface Props {
    to: string;
    newTab?: boolean;
    children?: ReactNode;
    className?: string;
}

export const ExternalLink = ({to, newTab, children, className}: Props) => (
    <InnerLink href={to} target={newTab ? '_blank' : '_self'} className={className}>
        {children}
    </InnerLink>
);
